import React, { useState, useEffect } from 'react';
import { artistActions } from '../../actions';

import { ICONS } from '../../constants/icons.constants';
import { useNavigate, useParams } from 'react-router-dom';
import Table from '../../components/table/Table';
import styles from './artistDetailPage.module.scss';
import { columns } from '../../config/artistDetails.config';

import CircularProgress from '../../components/circularProgress';

import Icons from '../../components/icons';
import { countries } from '../../constants/general.constants';

const ArtistDetailPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [artistDetail, setArtistDetail] = useState([]);
  const [songs, setSongs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleNavigate = () => {
    navigate('/artists');
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const response = await artistActions.fetchArtistById(
        params?.id
      );

      setArtistDetail(response.artist);
      setSongs(response.songs);
      setIsLoading(false);
    })();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className={styles.loaderContainer}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <div className={styles.header} onClick={handleNavigate}>
            <Icons type={ICONS.BACK_ARROW} />

            <p className={styles.artist}>Artist</p>
          </div>

          <div className={styles.artistSectionDetail}>
            <img
              className={styles.image2}
              src={`${process.env.REACT_APP_BASE_URL}/media/images/${artistDetail.profile_img}`}
              alt='artist'
            />

            <div className={styles.leftContent}>
              <p className={styles.name}>{artistDetail.name}</p>
              {countries.map((country) => {
                if (country.value === artistDetail.country) {
                  return (
                    <p
                      key={country.value}
                      className={styles.lastname}>
                      {country.label}
                    </p>
                  );
                }
                return null;
              })}

              <p
                className={
                  styles.songname
                }>{`Stage Name- ${artistDetail.stage_name}`}</p>
            </div>
          </div>

          <Table
            rows={songs}
            columns={columns}
            className={styles.table}
          />
        </>
      )}
    </>
  );
};

export default ArtistDetailPage;
